import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.confirmed = false;
    new bootstrap.Modal(this.element).show();
  }

  confirm() {
    this.confirmed = true;
  }

  redirectOnDismiss() {
    if (!this.confirmed) {
      window.location = '/';
    }
  }
}
